import { create } from "zustand";

export const useVisaValdaStore = create((set) => ({
  visaValda: false,
  setVisaValda: (value) => set({ visaValda: value }),
}));
